import type { PropsWithChildren, ReactNode, Ref } from "react";
import classNames from "classnames";
import { CopyOnClick } from "@design-system/CopyOnClick/CopyOnClick";
import "./BankNumber.scss";

interface BankNumberProps {
    title?: ReactNode;
    value: string;
    className?: string;
    tooltipText?: string;
}

export const BankNumber = ({
    children,
    title,
    value,
    className,
    ref,
    ...other
}: PropsWithChildren<BankNumberProps> & { ref?: Ref<HTMLSpanElement> }) => (
    <span ref={ref}>
        <CopyOnClick
            className={classNames("bank-number", className)}
            value={value}
            {...other}
        >
            <div className="bank-number__number">{children ?? value}</div>
            {title && <div className="bank-number__title">{title}</div>}
        </CopyOnClick>
    </span>
);
